import React, { useEffect, useState } from 'react'
import { ArrayTotalizarByProp } from '../../Actions/TotalizarProps';
import { FormatMoney } from '../../../../Helpers/FormatNumber';

export const Nivel4Screen = ({ data, nivel3, n1total, n1totalanterior,group }) => {
    const [state, setState] = useState([]);
    const [nivel4, setNivel4] = useState([]);
    const [suma, setTotales] = useState({
        total: 0,
        totalanterior: 0,
        variacion: 0
    })
    useEffect(() => {
        if (data === undefined || data == null || data.lenght === 0) {
            setState([]);
            return;
        }

        var arrayfilter = data.filter(x => x.nivel3 === nivel3);
        setNivel4(arrayfilter);
        var array = arrayfilter.reduce(function (groups, item) {
            var val = item['nivel4']
            groups[val] = groups[val] || val;
            return groups;
        }, {});

        setState(Object.values(arrayfilter));
    }, [data])
    useEffect(() => {
        setTotales({
            total: ArrayTotalizarByProp(nivel4, "total"),
            totalanterior: ArrayTotalizarByProp(nivel4, 'totalanterior'),
            variacion: ArrayTotalizarByProp(nivel4, 'variacion')
        })
    }, [nivel4])

    if (state.length == 0) return <div></div>

    const totales = (valor) => {
        return valor.substring(0, 5) === "TOTAL" ? "nivel4-totales" : "";

    }

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
      }; 

    return (
        <>
            {state.map(item => (
                <>
                    <tr className={`nivel4 ${totales(item.nivel4)}`}>
                        <td></td>
                        {/* <td></td> */}
                        <td colSpan={2}>{capitalizeWords(item.nivel4)}</td>
                        <td className={`importe ta-right ${item.total < 0 ? 'fcolor-red' : ''}`}> {FormatMoney(item.total, 0)}</td>
                        <td className={`importe ta-right ${item.mrgtotal < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(item.mrgtotal, 1)}</td>
                        <td className={`importe ta-right ${item.totalanterior < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(item.totalanterior, 0)}</td>
                        <td className={`importe ta-right ${item.mrgtotalanterior < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(item.mrgtotalanterior, 1)}</td>
                        <td className={`importe ta-right ${item.variacion < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(item.variacion, 0)}</td>
                        <td className={`importe ta-right ${item.mrgvariacion < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(item.mrgvariacion, 1)}</td>
                    </tr>
                </>
            ))}
            {
                state.length > 2 ?
                    <tr className='nivel-total-padding'>
                        {/* <td></td> */}
                        <td></td>
                        <td colSpan={2} className='nivel4-total'>Total {capitalizeWords(group)}</td>
                        <td className={`nivel4-total ta-right importe ${suma.total < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(suma.total, 0)}</td>
                        <td className={`nivel4-total ta-right importe ${suma.total < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(suma.total / n1total * 100, 1)}</td>
                        <td className={`nivel4-total ta-right importe ${suma.totalanterior < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(suma.totalanterior, 0)}</td>
                        <td className={`nivel4-total ta-right importe ${suma.totalanterior < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(suma.totalanterior / n1totalanterior * 100, 1)}</td>
                        <td className={`nivel4-total ta-right importe ${suma.variacion < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(suma.variacion, 0)}</td>
                        <td className={`nivel4-total ta-right importe ${suma.variacion < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(suma.variacion / suma.totalanterior * 100, 1)}</td>

                    </tr>
                    : <></>
            }
        </>
    )
}
